"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalService = void 0;
const ApprovalServiceLive_1 = require("./ApprovalServiceLive");
const ApprovalServiceStub_1 = require("./ApprovalServiceStub");
class ApprovalService {
    static create(stub = false) {
        if (stub) {
            return new ApprovalServiceStub_1.ApprovalServiceStub();
        }
        return new ApprovalServiceLive_1.ApprovalServiceLive();
    }
}
exports.ApprovalService = ApprovalService;
//# sourceMappingURL=ApprovalService.js.map